import { render } from "./jiaoyi-kanban.vue?vue&type=template&id=03ef3dff&scoped=true"
import script from "./jiaoyi-kanban.vue?vue&type=script&lang=js"
export * from "./jiaoyi-kanban.vue?vue&type=script&lang=js"

import "./jiaoyi-kanban.vue?vue&type=style&index=0&id=03ef3dff&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ef3dff"]])

export default __exports__